import { getCountryCodeFromContext } from '@urc-ui/utils/app-utils';
import { logger } from '@flexible-reports/services/logger';

const DEFAULT_TIMEZONE = 'America/Los_Angeles';

const MET_TIMEZONE = 'MET';

const TIMEZONE_OVERRIDES: Record<string, string> = {
  IT: 'Europe/Rome',
  ES: 'Europe/Madrid',
  FR: 'Europe/Paris',
  DE: 'Europe/Berlin'
};

const ETC_UNKNOWN_TZ = 'etc/unknown';

/**
 * The frontend app uses a date-time formatting libraries (react-18next, date-fns-tz) that use Intl.DateTimeFormat under
 * the hood. On old Chrome browsers (< v90), the Intl.DateTimeFormat library does not support the MET timezone and will
 * throw an error. This function will coerce MET timezones to city-based timezone names for the marketplaces in
 * TIMEZONE_OVERRIDES.
 * TODO: Investigate long term fix and remove the coercion: https://sim.amazon.com/issues/RCMRX-7156
 * @param timezone the timezone from window.AppContext
 * @return either the input timezone or a coerced timezone
 */
const getCoercedTimezone = (timezone: string) => {
  const countryCode = getCountryCodeFromContext();
  if (timezone === MET_TIMEZONE && TIMEZONE_OVERRIDES[countryCode]) {
    return TIMEZONE_OVERRIDES[countryCode];
  }

  return timezone;
};

/**
 * Timezone will be switched to user's browser timezone with global weblab dial up.
 * gets browsers timezone and falls back to marketplace timezone if there is an error
 * while reading browser's timezone.
 */
const getTimezone = (): string => {
  let timezone = window.AppContext?.marketplaceTimezone;
  try {
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!!browserTimezone && browserTimezone?.toLowerCase() !== ETC_UNKNOWN_TZ) {
      timezone = browserTimezone;
    }
  } catch (error) {
    logger.logFatalMessage(`There was an error while reading browser's timezone`, error);
  }

  if (timezone && typeof timezone === 'string') {
    return getCoercedTimezone(timezone);
  }
  return DEFAULT_TIMEZONE;
};

export { getTimezone };
